<template>
    <div class="comments">
        <h3>
            <!-- 留言板 -->
            {{ $t('ui.toolbox.bulletin_board.name') }}

            <i class="refresh icon" @click="fetch_comments" :title="$t('ui.general.update')"></i>
        </h3>

        <div class="ui divider"></div>
        <div v-if="is_processing || !is_initialized">
            <div class="ui inverted dimmer transition visible active" style="display: block !important;">
                <div class="ui text loader">
                    <!-- 處理中... -->
                    {{ $t('ui.general.initializing') }}
                </div>
            </div>
        </div>
        <div v-else class="contents">
            <div class="ui comments">
                <div v-if="comments.length == 0">
                    <!-- 尚無留言！ -->
                    {{ $t('ui.toolbox.bulletin_board.no_messages') }}
                </div>
                <Comment v-for="comment in comments" :comment="comment" :key="comment.identity">
                </Comment>
                <div class="ui divider"></div>
                <div class="comment">
                    <!-- <a class="avatar">
                        <img :src="avatar">
                    </a> -->
                    <div class="content">
                        <a class="author">
                            {{ commentor }}
                        </a>
                        <div class="metadata">
                            <span class="date"></span>
                        </div>
                        <div class="text ui form">
                            <input type="text" v-model="new_comment"
                            :placeholder="$t('ui.toolbox.bulletin_board.talk_your_comment')"
                            @keydown.enter="add_comment"
                            rows="1" ref="comment_input">
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <Paginator
            v-if="comments.length > 0"
            :total_pages="pagination.total_pages"
            :current_page="pagination.current_page"
            :change_page_channel="commentable_type + commentable_identity"
        />
    </div>
</template>

<script>
import Comment from "./comment.vue"
import Paginator from '@toolbox/pagination/paginator.vue'
export default {
    name: "ToolBulletinBoardComments",
    props: {
        commentable_type: String,
        commentable_identity: String,
        scope: String,
    },
    data() {
        return {
            is_initialized: false,
            is_processing: false,
            new_comment: null,
            comments: [],
            pagination: {
                total_pages: null,
                current_page: null,
            },
            errors: [],
            settings: {
                fetch_comments_url: null,
                add_comment_url: null,
                token: null,
            }
        }
    },
    watch: {
    },
    created() {
    },
    mounted() {
        this.init()
    },
    computed: {
        commentor() {
            if (this.scope == "provider") {
                return this.$store.state.provider.current_staff.name
            } else if (this.scope == "customer") {
                return this.$store.state.customer.customer.company_name
            }
        },
        avatar() {
            if (this.scope == "provider") {
                return "https://semantic-ui.com/images/avatar/small/matt.jpg"
            } else if (this.scope == "customer") {
                return "https://semantic-ui.com/images/avatar/small/elliot.jpg"
            }
        }
    },
    methods: {
        async init() {
            await new Promise(resolve => {
                this.is_initialized = false
                if (this.scope == "provider") {
                    this.settings.fetch_comments_url = this.$store.state.provider.routes.api_v1_provider_comments
                    this.settings.add_comment_url = this.$store.state.provider.routes.api_v1_provider_comments_create
                    this.settings.token = localStorage.getItem("authentication_token")
                } else if (this.scope == "customer") {
                    this.settings.fetch_comments_url = this.$store.state.customer.routes.api_v1_customer_comments
                    this.settings.add_comment_url = this.$store.state.customer.routes.api_v1_customer_comments_create
                    this.settings.token = localStorage.getItem("customer_authentication_token")
                }
                resolve()
            })
            await this.fetch_comments()
            await new Promise(resolve => {
                this.is_initialized = true
                resolve()
            })

            // pagination channel
            this.$bus.$off(this.commentable_type + this.commentable_identity)
            this.$bus.$on(this.commentable_type + this.commentable_identity, (page) => {
                this.pagination.current_page = page
                this.fetch_comments()
            })
        },
        fetch_comments() {
            this.is_processing = true
            var url = new RestUrl(this.settings.fetch_comments_url).parse(
                {
                    commentable_type: this.commentable_type,
                    commentable_identity: this.commentable_identity,
                },
                "?" + object_to_query({
                    page: this.pagination.current_page,
                })
            )
            return axios.get(url, {headers: { Authorization: this.settings.token }})
                .then(response => {
                    if (response.data.status == "success") {
                        this.comments = response.data.comments
                        this.pagination = response.data.pagination
                    } else if (response.data.status == "failure") {
                        this.errors = response.data.errors
                        // this.$noty.error("抓取留言失敗")
                        this.errors.push(
                            this.$t('ui.notifications.error.fetch__name', {
                                name: this.$t('models.comments'),
                                reason: ': ' + response.data.errors
                            })
                        )

                    }
                    this.is_processing = false
                    return response
                })
                .catch(error => {
                    // this.errors.push("抓取留言失敗" + error.response.status)
                    this.errors.push(
                        this.$t('ui.notifications.error.fetch__name', {
                            name: this.$t('models.comments'),
                            reason: ': ' + this.$t('ui.general.network_abnormality') + ',' + error.response.status
                        })
                    )

                    return Promise.reject(error)
                    this.is_processing = false
                })
        },
        add_comment() {
            if (this.new_comment) {
                this.is_processing = true
                var url = new RestUrl(this.settings.add_comment_url).parse(
                    {},
                )
                var params = {
                    commentable_type: this.commentable_type,
                    commentable_identity: this.commentable_identity,
                    content: this.new_comment,
                }
                this.new_comment = null
                return axios.post(url, params, {headers: { Authorization: this.settings.token }})
                .then(response => {
                    if (response.data.status == "success") {
                        this.fetch_comments()
                    } else if (response.data.status == "failure") {
                        this.errors = response.data.errors
                        // this.$noty.error("留言失敗")
                        this.$noty.error(
                            $t('ui.toolbox.bulletin_board.message') + ' ' +
                            this.$t('ui.general.fetch')
                        )
                    }
                    this.is_processing = false
                    return response
                })
                .catch(error => {
                    // this.errors.push("留言失敗" + error.response.status)
                    this.$noty.error(
                        $t('ui.toolbox.bulletin_board.message') + ' ' +
                        this.$t('ui.general.fetch') + ': ' +
                        error.response.status
                    )
                    return Promise.reject(error)
                    this.is_processing = false
                })
                .then(() => {
                    $(this.$refs.comment_input).focus()
                })
            }
        },
    },
    components: {
        Comment,
        Paginator,
    }
}
</script>

<style scoped>
.refresh.icon {
    cursor: pointer;
}
</style>
